query GetUniqueIssuesFilterOptions {
  uniqueness_issues(
    group: [issue_type, severity]
  ) {
    issue_type, severity
  }
}
